import React from "react";

/* Inline SVG glyphs for the IFU page.
   Kept local (instead of an icon package) so the exact leaflet look is under our
   control and nothing extra lands in the bundle. Every icon inherits colour and
   size from CSS via `currentColor` + a 100% width/height. */
const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

/* ---------- Section icons ---------- */

export const BellIcon = () => (
  <svg {...base}>
    <path d="M18 9.2a6 6 0 1 0-12 0c0 4.4-1.4 5.9-2 6.6h16c-.6-.7-2-2.2-2-6.6Z" />
    <path d="M10 19.2a2.2 2.2 0 0 0 4 0" />
  </svg>
);

export const EyeIcon = () => (
  <svg {...base}>
    <path d="M2.5 12S6 5.8 12 5.8 21.5 12 21.5 12 18 18.2 12 18.2 2.5 12 2.5 12Z" />
    <circle cx="12" cy="12" r="3.2" />
  </svg>
);

/* Lens going into the eye (insertion): eye + arrow pointing down into it */
export const LensInsertIcon = () => (
  <svg {...base}>
    <path d="M2.5 15S6 9.5 12 9.5 21.5 15 21.5 15 18 20.5 12 20.5 2.5 15 2.5 15Z" />
    <circle cx="12" cy="15" r="2.7" />
    <path d="M12 2v4.6M9.7 4.3 12 6.6l2.3-2.3" />
  </svg>
);

/* Lens coming out of the eye (removal): eye + arrow pointing up out of it */
export const LensRemoveIcon = () => (
  <svg {...base}>
    <path d="M2.5 15S6 9.5 12 9.5 21.5 15 21.5 15 18 20.5 12 20.5 2.5 15 2.5 15Z" />
    <circle cx="12" cy="15" r="2.7" />
    <path d="M12 6.6V2M9.7 4.3 12 2l2.3 2.3" />
  </svg>
);

export const CalendarIcon = () => (
  <svg {...base}>
    <rect x="3.5" y="5" width="17" height="15" rx="2.5" />
    <path d="M8 3v4M16 3v4M3.5 10h17" />
  </svg>
);

/* Washed hands / lens care */
export const HandCareIcon = () => (
  <svg {...base}>
    <path d="M12 4.4c1.7 2.1 2.7 3.5 2.7 4.8a2.7 2.7 0 1 1-5.4 0c0-1.3 1-2.7 2.7-4.8Z" />
    <path d="M5 13.6a7 7 0 0 0 14 0" />
    <path d="M4.4 17.8h15.2" />
  </svg>
);

export const ShieldPlusIcon = () => (
  <svg {...base}>
    <path d="M12 3 5 6v5.6c0 4.2 2.9 7.6 7 9.4 4.1-1.8 7-5.2 7-9.4V6l-7-3Z" />
    <path d="M12 9.2v5.6M9.2 12h5.6" />
  </svg>
);

export const SunIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2.6v2.2M12 19.2v2.2M4.3 4.3l1.6 1.6M18.1 18.1l1.6 1.6M2.6 12h2.2M19.2 12h2.2M4.3 19.7l1.6-1.6M18.1 5.9l1.6-1.6" />
  </svg>
);

export const AlertIcon = () => (
  <svg {...base}>
    <path d="M12 4.6 2.9 19.8h18.2L12 4.6Z" />
    <path d="M12 10.2v4.1M12 17h.01" />
  </svg>
);

export const BanIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M6 6l12 12" />
  </svg>
);

export const HeadsetIcon = () => (
  <svg {...base}>
    <path d="M4.6 14.2v-2.1a7.4 7.4 0 0 1 14.8 0v2.1" />
    <path d="M6.4 13.6H5.2a1.2 1.2 0 0 0-1.2 1.2v2.5a1.2 1.2 0 0 0 1.2 1.2h1.2Z" />
    <path d="M17.6 13.6h1.2a1.2 1.2 0 0 1 1.2 1.2v2.5a1.2 1.2 0 0 1-1.2 1.2h-1.2Z" />
    <path d="M20 18.5v.4a2.5 2.5 0 0 1-2.5 2.5H13.4" />
  </svg>
);

export const ChevronRightIcon = () => (
  <svg {...base}>
    <path d="M9.5 5.5 16 12l-6.5 6.5" />
  </svg>
);

/* ---------- Toolbar glyphs ---------- */

export const GlobeIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="8.6" />
    <path d="M3.4 12h17.2" />
    <path d="M12 3.4c2.2 2.4 3.3 5.2 3.3 8.6s-1.1 6.2-3.3 8.6c-2.2-2.4-3.3-5.2-3.3-8.6S9.8 5.8 12 3.4Z" />
  </svg>
);

export const SearchIcon = () => (
  <svg {...base}>
    <circle cx="11" cy="11" r="6.6" />
    <path d="m16 16 4.4 4.4" />
  </svg>
);

export const DownloadIcon = () => (
  <svg {...base}>
    <path d="M12 3.8v10.4" />
    <path d="m7.8 10.4 4.2 4.2 4.2-4.2" />
    <path d="M4.6 16.6v2.2a1.6 1.6 0 0 0 1.6 1.6h11.6a1.6 1.6 0 0 0 1.6-1.6v-2.2" />
  </svg>
);

export const PrinterIcon = () => (
  <svg {...base}>
    <path d="M7 8.4V3.6h10v4.8" />
    <path d="M7 17.2H5.2a1.8 1.8 0 0 1-1.8-1.8v-4.6a1.8 1.8 0 0 1 1.8-1.8h13.6a1.8 1.8 0 0 1 1.8 1.8v4.6a1.8 1.8 0 0 1-1.8 1.8H17" />
    <rect x="7" y="14.4" width="10" height="6" rx="1.2" />
  </svg>
);

export const MenuIcon = () => (
  <svg {...base}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const CloseIcon = () => (
  <svg {...base}>
    <path d="M6 6l12 12M18 6 6 18" />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg {...base}>
    <path d="m6.5 9.5 5.5 5.5 5.5-5.5" />
  </svg>
);

/* ---------- Symbols-guide glyphs ---------- */

export const HourglassIcon = () => (
  <svg {...base}>
    <path d="M7 3.2h10M7 20.8h10" />
    <path d="M8.2 3.2v3.4c0 2 3.8 3.4 3.8 5.4s-3.8 3.4-3.8 5.4v3.4" />
    <path d="M15.8 3.2v3.4c0 2-3.8 3.4-3.8 5.4s3.8 3.4 3.8 5.4v3.4" />
  </svg>
);

/* Standard "do not re-use" mark: a crossed-out 2 */
export const DoNotReuseIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="8.6" />
    <path d="M5.9 18.1 18.1 5.9" />
    <text
      x="12"
      y="15.8"
      textAnchor="middle"
      fontSize="10"
      fontWeight="700"
      fill="currentColor"
      stroke="none"
    >
      2
    </text>
  </svg>
);

/* "Do not use if packaging is damaged" */
export const DoNotUseIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="8.6" />
    <path d="M5.9 5.9 18.1 18.1" />
  </svg>
);

/* ---------- Lens insertion / removal figures ---------- */
export const EyeFigure = ({ variant = "insertion" }) => (
  <svg viewBox="0 0 200 150" fill="none" aria-hidden="true">
    {/* brow + upper lid */}
    <path d="M34 30c20-12 50-13 70-3" stroke="#33475f" strokeWidth="3" strokeLinecap="round" />
    {/* eyeball */}
    <path
      d="M22 66c22-30 78-30 100 0-22 30-78 30-100 0Z"
      fill="#ffffff"
      stroke="#33475f"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    {/* iris + pupil + highlight */}
    <circle cx="72" cy="66" r="20" fill="#bfdcef" stroke="#33475f" strokeWidth="3" />
    <circle cx="72" cy="66" r="8.5" fill="#33475f" />
    <circle cx="66" cy="60" r="3.2" fill="#ffffff" />

    {variant === "insertion" ? (
      <>
        {/* one index finger presenting the lens */}
        <path
          d="M80 150v-30a14 14 0 0 1 28 0v30"
          fill="#fbdfd0"
          stroke="#33475f"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <ellipse cx="94" cy="114" rx="15" ry="6" fill="#dff1fb" stroke="#33475f" strokeWidth="3" />
      </>
    ) : (
      <>
        {/* index + thumb pinching the lens off */}
        <path
          d="M62 150v-24a12 12 0 0 1 24 0v24"
          fill="#fbdfd0"
          stroke="#33475f"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <path
          d="M102 150v-24a12 12 0 0 1 24 0v24"
          fill="#fbdfd0"
          stroke="#33475f"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <ellipse cx="94" cy="104" rx="12" ry="5.5" fill="#dff1fb" stroke="#33475f" strokeWidth="3" />
      </>
    )}
  </svg>
);
